import React, { useState } from "react";
import DlLayout from "./DlLayout";
import MainLayout from "./MainLayout";

export default ({ children }) => {
  if (children?.key?.includes("dlg-disclosure")) {
    return <DlLayout>{children}</DlLayout>
  }
  return <MainLayout>{children}</MainLayout>
}